export enum BlueBoxTextType {

  hidden = -1,
  run = 0,
  drawThrow = 1,

}